// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Reports-Sales-SalesType-__SalesType___36gKs","tableWrapper":"app-pages-Reports-Sales-SalesType-__SalesType___3abHN","tableWrapperResponsive":"app-pages-Reports-Sales-SalesType-__SalesType___2Du2W","sales-type-table":"app-pages-Reports-Sales-SalesType-__SalesType___2a1s7","sales-type-table-responsive":"app-pages-Reports-Sales-SalesType-__SalesType___3UB2U","body-sales-type-collected":"app-pages-Reports-Sales-SalesType-__SalesType___ude_Z","foot-sales-type-collected":"app-pages-Reports-Sales-SalesType-__SalesType___6sBcf"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Reports/Sales/SalesType/SalesType.css
// module id = 2491
// module chunks = 0